export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/blog": [21],
		"/blog/[slug]": [22],
		"/(marketing)/bootcamps": [7],
		"/contact": [23,[2]],
		"/(marketing)/customer-education": [8],
		"/(redirects)/demo": [~10],
		"/(redirects)/devanddesign": [~11],
		"/(redirects)/discord": [~12],
		"/(marketing)/employee-training": [9],
		"/(redirects)/github": [~13],
		"/(redirects)/learn": [~14],
		"/(redirects)/new": [~15],
		"/oss-friends": [24],
		"/(redirects)/ph": [~16],
		"/pricing": [25,[3]],
		"/(redirects)/privacy": [~17],
		"/roadmap": [26],
		"/(redirects)/signup": [~18],
		"/teach": [27,[4]],
		"/teach/register": [~28,[4]],
		"/tools": [29,[5]],
		"/tools/name-picker": [30,[5]],
		"/tools/pomodoro": [31,[5]],
		"/tools/progress": [32,[5]],
		"/tools/stopwatch": [33,[5]],
		"/tools/tic-tac-toe": [34,[5]],
		"/(redirects)/tos": [~19],
		"/(redirects)/waec": [~20]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';